/**
 * 错误页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const errorCommonConfig = {
  texts: {
    defaultMessage: 'Server error',
    retry: 'Retry',
    home: 'Home',
  },
}
